module.exports = __webpack_public_path__ + "files/dc0cdca451a60d0ee184aa295125d5fe.png";